const StoreCardShimmer = () => {
  return (
    <div className="border-1 border-lightSliver rounded-[10px] md:rounded-3xl p-3 md:p-5 lg:p-6 bg-white">
      <div className="flex justify-between gap-3 md:gap-5 flex-nowrap items-stretch h-full">
        <div className="relative h-[80px] md:h-[120px] 2xl:h-[180px] w-[100px] md:w-[150px] 2xl:w-[250px] rounded-[3.97px] md:rounded-[14px] overflow-hidden shrink-0 bg-gray-200">
          <div className="shimmer absolute inset-0" />
        </div>
        <div className="space-y-2 md:space-y-5 flex-1 flex flex-col justify-between">
          <div className="h-4 md:h-6 w-3/4 rounded bg-gray-200 overflow-hidden relative">
            <div className="shimmer absolute inset-0" />
          </div>
          <div className="space-y-2.5">
            <div className="h-3 md:h-4 w-1/2 rounded bg-gray-200 overflow-hidden relative">
              <div className="shimmer absolute inset-0" />
            </div>
            <div className="h-3 md:h-4 w-full rounded bg-gray-200 overflow-hidden relative">
              <div className="shimmer absolute inset-0" />
            </div>
            <div className="h-3 md:h-4 w-4/5 rounded bg-gray-200 overflow-hidden relative">
              <div className="shimmer absolute inset-0" />
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="h-3 md:h-5 w-20 rounded bg-gray-200 overflow-hidden relative">
              <div className="shimmer absolute inset-0" />
            </div>
            <div className="h-3 md:h-5 w-24 rounded bg-gray-200 overflow-hidden relative">
              <div className="shimmer absolute inset-0" />
            </div>
          </div>
          <div className="flex gap-2 mt-2 md:mt-4">
            <div className="h-8 md:h-10 w-full rounded-full bg-gray-200 overflow-hidden relative">
              <div className="shimmer absolute inset-0" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreCardShimmer;
